import React, { useContext } from 'react'
import { Form, Select } from 'semantic-ui-react'
import { BookerContext } from "~/contexts/BookerContext"
import { SiteProps } from '../../../interfaces'
import electricOptions from './electricOptions'
import classNames from '../../../utils/classNames'
import { getTextColorBasedOnBackground } from '../Prerequisites'

interface ComponentProps {
  sites: SiteProps[]
  userAmps: string
  handleAmpsChange: (e: React.SyntheticEvent, obj: object) => void
  error: string
  setError: (v: string) => void
}

const ElectricField = ({ sites, userAmps, handleAmpsChange, error, setError }: ComponentProps) => {
  const { campingStyle, secondaryColor } = useContext(BookerContext)

  const campingStyleSites = sites.filter((site) => site.camping_style_id == campingStyle.id && site.is_bookable)

  return (
    <Form.Field required>
      <div className='font-bold text-lg mb-1'>
        Preferred amperage
      </div>
      <div className='flex overflow-x-auto gap-3.5 py-1'>
        {electricOptions(campingStyleSites)
          .filter((option) => option.value)
          .map(({ key, value, text }) => {
            return (
              <div
                role="button"
                style={{
                  borderRadius: 12,
                  borderColor: userAmps === value && secondaryColor,
                  background: userAmps === value && secondaryColor,
                  color: userAmps === value && getTextColorBasedOnBackground(secondaryColor),
                }}
                key={key}
                onClick={(e) => {
                  setError('')
                  handleAmpsChange(e, { value })
                }}
                className={classNames('py-3 px-8 text-base flex justify-center items-center cursor-pointer whitespace-nowrap border font-semibold')}
              >
                {value === 'none' ? text : `${value}A`}
              </div>
            )
          })}
      </div>
      {error ? <div className="text-red-600 font-semibold">Please specify your preferred amperage</div> : <></>}
      </Form.Field>
  )
}

export default ElectricField
